<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                    </div>
                    <el-table
                    v-loading="isLoading"
                    :data="tableData"
                    :height="bodyHeight-130"
                    style="width: 100%">
                        <el-table-column
                            label="等级">
                            <template slot-scope="scope">
                                {{scope.row.Id}}级
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="DayOrderCount"
                            label="当天做单数量">
                        </el-table-column>
                        <el-table-column
                            prop="DayMoneySum"
                            label="当天做单金额">
                        </el-table-column>
                        <el-table-column
                            prop="WeekOrderCount"
                            label="一周做单数量">
                        </el-table-column>
                        <el-table-column
                            prop="WeekMoneySum"
                            label="一周做单金额">
                        </el-table-column>
                        <el-table-column
                            prop="HalfMonthOrderCount"
                            label="半个月做单数量">
                        </el-table-column>
                        <el-table-column
                            prop="HalfMonthMoneySum"
                            label="半个月做单金额">
                        </el-table-column>
                        <el-table-column
                            prop="MonthOrderCount"
                            label="一月做单数量">
                        </el-table-column>
                        <el-table-column
                            prop="MonthMoneySum"
                            label="一月做单金额">
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            width="300px">
                            <template slot-scope="scope">
                                <el-button type="success" plain @click="openUpdateForm(scope.row)">编辑</el-button>
                                  <el-button type="danger" plain @click="del(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog :title="formTitle" :visible.sync="dialogFormVisible" width="400px">
            <el-form :model="newModel"   ref="ruleForm" label-width="120px">
                <el-form-item label="当天做单数量" prop="DayOrderCount">
                    <el-input placeholder="请输入当天做单数量" v-model="newModel.DayOrderCount"></el-input>
                </el-form-item>
                <el-form-item label="当天做单金额" prop="DayMoneySum">
                    <el-input placeholder="请输入当天做单金额" v-model="newModel.DayMoneySum"></el-input>
                </el-form-item>
                <el-form-item label="一周做单数量" prop="WeekOrderCount">
                    <el-input placeholder="请输入一周做单数量" v-model="newModel.WeekOrderCount"></el-input>
                </el-form-item>
                <el-form-item label="一周做单金额" prop="WeekMoneySum">
                    <el-input placeholder="请输入一周做单金额" v-model="newModel.WeekMoneySum"></el-input>
                </el-form-item>
                <el-form-item label="半个月做单数量" prop="HalfMonthOrderCount">
                    <el-input placeholder="请输入半个月做单数量" v-model="newModel.HalfMonthOrderCount"></el-input>
                </el-form-item>
                <el-form-item label="半个月做单金额" prop="HalfMonthMoneySum">
                    <el-input placeholder="请输入半个月做单金额" v-model="newModel.HalfMonthMoneySum"></el-input>
                </el-form-item>
                <el-form-item label="一月做单数量" prop="MonthOrderCount">
                    <el-input placeholder="请输入一月做单数量" v-model="newModel.MonthOrderCount"></el-input>
                </el-form-item>
                <el-form-item label="一月做单金额" prop="MonthMoneySum">
                    <el-input placeholder="请输入一月做单金额" v-model="newModel.MonthMoneySum"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getMakeConfig,UpdateMake } from '@/api/makeConfig'
import { constantRoutes } from "@/router"
export default {
    data(){
        return {
            dialogFormVisible:false,
            formTitle:"",
            total:0,
            formId:null,
            bodyHeight:0,
            isLoading:false,
            newModel:{
                DayOrderCount:0,
                DayMoneySum:0,
                WeekOrderCount:0,
                WeekMoneySum:0,
                HalfMonthOrderCount:0,
                HalfMonthMoneySum:0,
                MonthOrderCount:0,
                MonthMoneySum:0
            },
            rules: {
                DayOrderCount: [
                    { min: 1, max: 11, message: '长度在 1 到 11 个字符', trigger: 'blur' }
                ],
                DayMoneySum: [
                    { min: 1, max: 9, message: '长度在 1 到 9 个字符', trigger: 'blur' }
                ],
                WeekOrderCount: [
                    { min: 1, max: 11, message: '长度在 1 到 11 个字符', trigger: 'blur' }
                ],
                WeekMoneySum: [
                    { min: 1, max: 9, message: '长度在 1 到 9 个字符', trigger: 'blur' }
                ],
                HalfMonthOrderCount: [
                    { min: 1, max: 11, message: '长度在 1 到 11 个字符', trigger: 'blur' }
                ],
                HalfMonthMoneySum: [
                    { min: 1, max: 9, message: '长度在 1 到 9 个字符', trigger: 'blur' }
                ],
                MonthOrderCount: [
                    { min: 1, max: 11, message: '长度在 1 到 11 个字符', trigger: 'blur' }
                ],
                MonthMoneySum: [
                    { min: 1, max: 9, message: '长度在 1 到 9 个字符', trigger: 'blur' }
                ]
            },
            tableData:[]
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){
        this.menus = constantRoutes[0].children.filter(item => {
            return item.meta.showInMenu == true
        })
    },
    methods: {
        openUpdateForm(info) {
            this.newModel.QQ = info.QQ
            this.newModel.DayOrderCount = info.DayOrderCount
            this.newModel.DayMoneySum = info.DayMoneySum
            this.newModel.WeekOrderCount = info.WeekOrderCount
            this.newModel.WeekMoneySum = info.WeekMoneySum
            this.newModel.HalfMonthOrderCount = info.HalfMonthOrderCount
            this.newModel.HalfMonthMoneySum = info.HalfMonthMoneySum
            this.newModel.MonthOrderCount = info.MonthOrderCount
            this.newModel.MonthMoneySum = info.MonthMoneySum
            this.formTitle = '编辑'
            this.dialogFormVisible = true
            this.formId = info.Id
        },
        submitForm() {
                this.update()
        },
        update(){
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    UpdateMake(this.formId,this.newModel)
                    .then(() => {
                    this.$message({
                        message: "修改成功！",
                        type: 'success'
                    });
                    this.query()
                    this.dialogFormVisible = false
                    })
                    .catch(err => {
                        console.log(err)
                    })
                } else {
                    return false;
                }
            });
        },
        query(){
            this.isLoading=true;
            
            getMakeConfig().then(res => {
                this.tableData=res.data.Result
                this.isLoading = false
                })
            .catch(err => {
                console.log(err)
                this.isLoading = false
            });
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>